<template>
    <div>
        <app-page-header></app-page-header>
        <v-container grid-list-xl style="margin-top:-13px;" fluid>
            <!-- kriterij iskanja -->
            <v-layout row wrap fill-height>
                <v-flex xs12 sm12 md12 lg12>
                    <v-card>
                        <v-toolbar
                        card 
                        :color="filterToolbarColor">
                            <v-icon medium>filter_list</v-icon>
                            <v-toolbar-title class="body-2">Kriterij iskanja</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!--<v-icon medium>undo</v-icon>-->
                            <v-btn icon @click="showDataTableFilters= !showDataTableFilters">
                                <v-icon @click="">{{ showDataTableFilters? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider v-show="showDataTableFilters"></v-divider><!--<br v-show="showDataTableFilters">-->
                        <v-card-text v-show="showDataTableFilters">
                            <!--<v-layout row wrap>
                                <v-flex xs12 sm12 md4 lg3>
                                    <v-btn @click="clickToScan" v-show="!displayScanNrInput" block color="warning" dark>Klikni tukaj za skeniranje</v-btn>
                                    <v-form ref="form"
                                    v-model="form"
                                    append>
                                        <v-text-field
                                            v-model="scanNr"
                                            label="Prisloni kartico na optični čitalnik...."
                                            v-show="displayScanNrInput"
                                            ref="scan_input"
                                            @keydown.enter.prevent="scanCard"
                                            id="scanInputField"
                                        ></v-text-field>
                                        
                                    </v-form>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6>
                                    <v-checkbox @change="displayResults" :class="{ 'ma-3' : displayScanNrInput, 'ma-2' : !displayScanNrInput  }" v-model="blockedUsers" :label="`Prikaži samo blokirane kartice: ${checkboxBlockedCardsOnlyLabel}`"></v-checkbox>
                                </v-flex>
                            </v-layout>-->

                            <v-layout row wrap>
                                <v-flex xs12 sm12 md4 lg3>
                                    <v-btn class="mt-3" @click="clickToScan" v-show="!displayScanNrInput" block color="warning" dark>Klikni tukaj za skeniranje</v-btn>
                                    <v-form ref="form"
                                    v-model="form"
                                    append>
                                        <v-text-field
                                            v-model="scanNr"
                                            label="Prisloni kartico na optični čitalnik...."
                                            v-show="displayScanNrInput"
                                            ref="scan_input"
                                            @keydown.enter.prevent="scanCard"
                                            id="scanInputField"
                                            class="ml-4 cb"
                                        ></v-text-field>
                                        
                                    </v-form>
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6 id="abc">
                                    <v-checkbox @change="displayResults" class="ti" v-model="blockedUsers" :label="`Prikaži samo blokirane kartice: ${checkboxBlockedCardsOnlyLabel}`"></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <data-table
            :settings="dataTableSettings"
            :queryParameters="queryParameters"
            ></data-table>
        </v-container>


        <!-- data table toggle columns menu -->
        <data-table-toggle-columns
        :dataTableId="dataTableSettings.id"
        :columns="dataTableSettings.headers"
        dataTableColumnsMenuId="users-list-toggle-menu"

        ></data-table-toggle-columns>
    </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import DataTableToggleColumns from '@/components/DataTableToggleColumns.vue'
import { getUserSettingsFromStorage, storeUserSettingsToLocalStorage } from '@/helpers/utilities.js'
import { EventBus } from '@/main.js'

export default {
    components: {
        DataTable,
        DataTableToggleColumns
    },

    data: () => ({
        showDataTableFilters: true,
        blockedUsers: false,
        scanBtn: true,
        scanNr: null,
        form: true,

        dataTableSettings: {
            id: 'dTusersList',
            title: 'Uporabniki',
            sortColumn: 'name',
            sortDirection: 'asc',
            headers: [
                { text: "Ime in priimek", value: "name", class: "text-xs-left", visibility: true},
                { text: "Tip omejitve", value: "restriction", class: "text-xs-left", visibility: true },
                { text: "ID kartice", value: "card_id", class: "text-xs-left", visibility: true },
                { text: "Št. kartice", value: "card_number", class: "text-xs-left", visibility: true },
                { text: "Registrska št. 1", value: "registration_number_1", class: "text-xs-left", visibility: true },
                { text: "Registrska št. 2", value: "registration_number_2", class: "text-xs-left", visibility: true },
                { text: "Registrska št. 3", value: "registration_number_3", class: "text-xs-left", visibility: true },
                { text: "Registrska št. 4", value: "registration_number_4", class: "text-xs-left", visibility: true },
                { text: "Registrska št. 5", value: "registration_number_5", class: "text-xs-left", visibility: true },
                { text: "Upravljanje", value: "", align: "right", class: "text-xs-right", sortable: false, visibility: true},

            ],
            updateInterval: false,
            rowsPerPage: 10,
            endpoint: "blejski-grad/rfid-users",
            editItem: {
                route: "edit-user"
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: true,
                    addNewRoute: 'add-user',
                    toggleColumns: true
                }
            },

            eventBus: {
                refreshDataTable: 'blejskiGradUsersList',
                totalItems : {
                    event: ''
                },
                search: 'blejski-grad-nrSearch',
                toggleColumnsId: 'toggle-users-list-columns'
            }
        },
    }),

    watch: {

    },

    computed: {
        filterToolbarColor() {
            return (this.showDataTableFilters) ? 'transparent' : 'transparent'
        },

        queryParameters() {
            return {
                blockedUsers: this.blockedUsers
            }
        },

        checkboxBlockedCardsOnlyLabel() {
            if(this.blockedUsers) {
                return "DA"
            }

            return "NE"
        },

        displayScanNrInput() {
            if(!this.scanBtn) {
                return true
            }

            return false
        },

        getDataTableHeaders() {
           
        }
    },

    methods: {
        displayResults() {
            setTimeout(() => {
                EventBus.$emit(this.dataTableSettings.eventBus.refreshDataTable, 'pass-some-data');
            }, 250)
        },

        clickToScan() {
            this.scanBtn = false
            this.setFocus()
            var vm = this
        },

        setFocus() {
            if(!this.scanBtn) {
                var vm = this
                setTimeout(() => {
                    vm.$refs.scan_input.focus()
                }, 250)
            }
        },

        scanCard() {
            var vm = this
            vm.$store.commit('SET_PROGRESS', true)
            this.$store.dispatch('RFID_NR_SEARCH', this.scanNr)
            .then(response => {
                //console.log(response)
                //console.log(response.data.rfidNr)
                EventBus.$emit(this.dataTableSettings.eventBus.search, response.data.rfidNr.toString());
                this.scanNr = null
                this.scanBtn = true
                vm.$store.commit('SET_PROGRESS', false)
            })
            .catch(error => {
                this.scanNr = null
                this.scanBtn = true
                vm.$store.commit('SET_PROGRESS', false)
                vm.$store.commit('snackbarDisplay', true)
                vm.$store.commit('snackbarMode', 'multi-line')
                vm.$store.commit('snackbarText', 'Pri skeniranju kartice je prišlo do napake. Prosimo poskusite ponovno.')
                vm.$store.commit('snackbarDisplay', true)
            })
        }
    },

    created() {
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
    },

    mounted() {
        var vm = this
        EventBus.$on(this.dataTableSettings.eventBus.toggleColumnsId, (data) => {
            if(data.toggleColumnsMenu) {
                //console.log(data)
                EventBus.$emit('users-list-toggle-menu', {openColumnsMenu: true})
            }
        })

        EventBus.$on(this.dataTableSettings.id, (data) => {
            if(data.columns) {
                //console.log(data)
            }

            if(data.dataTableHeaders) {
                //console.log(data)
                for(var i=0; i<this.dataTableSettings.headers.length; i++) {
                    var headerFound = false;
                    for(var k=0; k<data.dataTableHeaders.length; k++) {
                        if(this.dataTableSettings.headers[i].value == data.dataTableHeaders[k]) {
                            this.dataTableSettings.headers[i].visibility = true
                            headerFound = true
                        }
                    }

                    if(headerFound == false) {
                        //console.log(this.dataTableSettings.headers[i])
                        this.dataTableSettings.headers[i].visibility = false
                    }
                }
            }
        })

        document.getElementById("scanInputField").addEventListener("blur", function(){
            vm.scanBtn = true
        });


        /*storeUserSettingsToLocalStorage("app_kpss_1", {
            "usersList": ['name', 'restriction', 'card_id']
        });*/

        /*var userSettings = getUserSettingsFromStorage("app_kpss_1")
        if(userSettings.hasOwnProperty('dTusersList')) {
            for(var i=0; i<this.dataTableSettings.headers.length; i++) {
                    var headerFound = false;
                    for(var k=0; k<userSettings.usersList.length; k++) {
                        if(this.dataTableSettings.headers[i].value == userSettings.usersList[k]) {
                            this.dataTableSettings.headers[i].visibility = true
                            headerFound = true
                        }
                    }

                    if(headerFound == false) {
                        //console.log(this.dataTableSettings.headers[i])
                        this.dataTableSettings.headers[i].visibility = false
                    }
                }   
        }*/

    },

    destroyed() {
        EventBus.$off(this.dataTableSettings.eventBus.toggleColumnsId)
        EventBus.$off(this.dataTableSettings.id)
    }
}
</script>

<style scoped>
    #abc .ti {
        padding-top:7px !important;
    }
</style>